"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultHrConfig = void 0;
var defaultHrConfig = {
    color: '#000000',
    height: 2,
    width: 120,
    margin: {
        desktop: '20px auto',
        tablet: '20px auto',
        mobile: '20px auto'
    }
};
exports.defaultHrConfig = defaultHrConfig;
//# sourceMappingURL=Hr.js.map